import {useNavigate, useSearchParams} from "react-router-dom";
import {companySelector, useGetCompanyQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {CompanyProfile} from "../../components/profile/CompanyProfile/CompanyProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const CompanyProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.company", "Company") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <CompanyProfilePage id={id}/>;
};

export const CompanyProfilePage = (props: Props) => {
  const {id} = props;

  const selectCompany = useMemo(() => {
    return companySelector()
  }, []);

  const {company, isFetching} = useGetCompanyQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      company: selectCompany(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage
      entity={company}
      isLoading={isFetching}
      permissions={["company_view"]}
    >
      {(entity) => (
        <CompanyProfile company={entity}/>
      )}
    </EntityProfilePage>
  )
};
